import { combineReducers } from 'redux';
import productSegment from './productSegment/ProductSegmentState';

const InsightReducer = combineReducers({
  productSegment,
});

export default InsightReducer;
